<template>
  <div class="analysis-result" v-if="data && data.analysisResult">
    <!-- 整体评分 -->
    <el-card shadow="hover">
      <div class="highlight">
        <el-tag class="score-right" :type="getScoreType(data.analysisResult.overall_score, 100)" size="small">
          {{ data.analysisResult.overall_score }}
        </el-tag>
        <div>{{ $t('gpt.overallScore') }} (100)</div>
      </div>
    </el-card>

    <el-card class="primnum-card" shadow="hover">
      <el-row>
        <div class="primnum">
          <div class="logo" style="float: left; margin-right: 16px;">
            <el-image style="margin-top: -10px;" :src="require('@/assets/premium.png')" fit="contain" />
          </div>
          <div class="primnum-right">
            <div class="title" style="margin-top: -2px;margin-bottom: 4px;">{{ $t('gpt.premiumService') }}</div>
            <div class="desc">{{ $t('gpt.premiumServiceDesc') }}</div>
          </div>
        </div>
        <div class="primnum-right">
          <el-button type="primary" @click="execGenerate()" icon="el-icon-plus"
            :loading="task && (task.status == 'running' || task.status == 'waiting')">
            {{ task ? $t('common.regenerate') : $t('common.generate') }}</el-button>
        </div>
      </el-row>
      <div v-if="task && task.status == 'done'">
        <el-divider content-position="center">{{ $t('gpt.upgrade') }}</el-divider>
        <el-row :gutter="16">
          <el-col :span="12">
            <div class="score-summary">{{ $t('gpt.before') }}</div>
            <el-image class="content-image" :src="data.url | imageUrl(false)"
              :preview-src-list="[imageUrl(data.url, false)]" fit="contain" />
          </el-col>
          <el-col :span="12">
            <div class="score-summary">{{ $t('gpt.after') }}</div>
            <el-image class="content-image" :src="task && task.imagePath | imageUrl(false)"
              :preview-src-list="[imageUrl(task.imagePath, false)]" fit="contain" />
          </el-col>
        </el-row>
      </div>
    </el-card>

    <!-- 各维度分析 -->
    <el-divider class="analysis-divider" content-position="left">{{ $t('gpt.dimensionalAnalysis') }}</el-divider>
    <el-row :gutter="16" style="margin-bottom: -16px;">
      <el-col :span="12">
        <el-row v-for="item in oddAnalysisItems" :key="item[0]">
          <el-card shadow="hover" style="margin-bottom: 16px;">
            <div class="score-summary">
              <el-tag size="small" class="score-right" :type="getScoreType(item[1].score, 10)">{{ item[1].score
              }}</el-tag>
              <div>{{ $t("gpt." + item[0]) + " " + $t("gpt.score") + ' (10)' }}</div>
            </div>
            <div class="content-text">{{ item[1].comment }}</div>
          </el-card>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row v-for="item in evenAnalysisItems" :key="item[0]">
          <el-card shadow="hover" style="margin-bottom: 16px;">
            <div class="score-summary">
              <el-tag size="small" class="score-right" :type="getScoreType(item[1].score, 10)">{{ item[1].score
              }}</el-tag>
              <div>{{ $t("gpt." + item[0]) + " " + $t("gpt.score") + ' (10)' }}</div>
            </div>
            <div class="content-text">{{ item[1].comment }}</div>
          </el-card>
        </el-row>
      </el-col>
    </el-row>

    <!-- 优势 -->
    <el-divider class="analysis-divider" content-position="left">{{ $t('gpt.advantage') }}</el-divider>
    <el-row style="margin-bottom: -16px;">
      <el-col :span="24">
        <el-card shadow="hover" style="margin-bottom: 16px;">
          <div class="content-text" v-for="(strength, index) in data.analysisResult.strengths" :key="index">
            <i class="el-icon-check" style="color: #67C23A; margin-right: 8px;"></i>
            {{ strength }}
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 改进建议 -->
    <el-divider class="analysis-divider" content-position="left">{{ $t('gpt.improvements') }}</el-divider>
    <el-row :gutter="16" style="margin-bottom: -16px;">
      <el-col :span="24" v-for="(improvement, index) in data.analysisResult.improvements" :key="index">
        <el-card shadow="hover" style="margin-bottom: 16px;">
          <div class="score-summary">
            {{ improvement.category }}
            <el-tag class="score-right" :type="getPriorityType(improvement.priority)" size="small">
              {{ $t('gpt.' + improvement.priority) }}
            </el-tag>
          </div>
          <div class="content-text">{{ improvement.suggestion }}</div>
        </el-card>
      </el-col>
    </el-row>


    <!-- 搭配建议 -->
    <el-divider class="analysis-divider" content-position="left">{{ $t('gpt.recommendations') }}</el-divider>
    <el-row :gutter="16" style="margin-bottom: 20px;">
      <!-- 添加物品 -->
      <el-col :span="12">
        <el-card shadow="hover" style="margin-bottom: 16px;">
          <div class="score-summary">{{ $t('gpt.items_to_add') }}</div>
          <div v-for="(item, index) in data.analysisResult.recommendations.items_to_add" :key="index">
            <div class="content-text"><i class="el-icon-plus" style="color: #67C23A; margin-right: 8px;"></i>
              {{ item }}</div>
          </div>
        </el-card>
      </el-col>

      <!-- 更换物品 -->
      <el-col :span="12">
        <el-card shadow="hover" style="margin-bottom: 16px;">
          <div class="score-summary">{{ $t('gpt.items_to_change') }}</div>
          <div v-for="(item, index) in data.analysisResult.recommendations.items_to_change" :key="index">
            <div class="content-text"><i class="el-icon-minus" style="color: #F56C6C; margin-right: 8px;"></i>
              {{ item }}</div>
          </div>
        </el-card>
      </el-col>

      <!-- 造型技巧 -->
      <el-col :span="24">
        <el-card shadow="hover" style="margin-bottom: 16px;">
          <div class="score-summary" style="margin-bottom: 8px;">{{ $t('gpt.styling_tips') }}</div>
          <div class="content-text">
            <div v-for="(tip, index) in data.analysisResult.recommendations.styling_tips" :key="index">
              <i class="el-icon-thumb" style="color: #409EFF; margin-right: 8px;"></i>
              {{ tip }}
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!-- 适用场合 -->
    <el-divider class="analysis-divider" content-position="left">{{ $t('gpt.occasion_appropriateness') }}</el-divider>
    <el-row style="margin-bottom: 20px;">
      <el-col :span="24">
        <div style="display: flex; flex-wrap: wrap; gap: 8px;">
          <el-tag v-for="(occasion, index) in data.analysisResult.alternative_occasions" :key="index" type="info"
            size="medium">
            {{ occasion }}
          </el-tag>
        </div>
      </el-col>
    </el-row>

    <!-- 最终建议 -->
    <el-divider class="analysis-divider" content-position="left">{{ $t('gpt.finalAdvice') }}</el-divider>
    <el-row style="margin-bottom: 20px;">
      <el-col :span="24">
        <el-card shadow="hover">
          <p class="content-text" style="font-style: italic; margin: 0;">
            <i class="el-icon-chat-dot-round" style="color: #409EFF; margin-right: 8px;"></i>
            {{ data.analysisResult.final_advice }}
          </p>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { execGenerate, queryGenerate } from "@/api/gpt";
import { imageUrl } from "@/filters";
export default {
  name: 'AnalysisResult',
  data() {
    return {
      task: null,
      timer: null,
    };
  },
  props: {
    data: {
      type: Object,
      default: null
    },
  },
  computed: {
    // 计算奇数索引的分析结果项
    oddAnalysisItems() {
      if (!this.data || !this.data.analysisResult || !this.data.analysisResult.analysis) {
        return [];
      }

      const items = Object.entries(this.data.analysisResult.analysis);
      return items.filter((item, index) => index % 2 === 0);
    },

    // 计算偶数索引的分析结果项
    evenAnalysisItems() {
      if (!this.data || !this.data.analysisResult || !this.data.analysisResult.analysis) {
        return [];
      }

      const items = Object.entries(this.data.analysisResult.analysis);
      return items.filter((item, index) => index % 2 === 1);
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer);
  },
  methods: {
    // 根据分数获取标签类型
    getScoreType(score, fullScore = 100) {
      if (score >= 80 && fullScore == 100 || score >= 8 && fullScore == 10) return 'success';
      if (score >= 60 && fullScore == 100 || score >= 6 && fullScore == 10) return 'warning';
      return 'danger';
    },

    // 根据优先级获取标签类型
    getPriorityType(priority) {
      if (priority === 'high') return 'danger';
      if (priority === 'medium') return 'warning';
      return '';
    },

    execGenerate() {
      execGenerate(this.data.id).then(response => {
        if (response.success) {
          this.$notify({
            title: this.$t("tagger.restartSucc"),
            type: "success",
          });
          this.queryGenerate();
        }
      });
    },

    queryGenerate() {
      queryGenerate(this.data.id).then(response => {
        this.task = response.result;
        if (this.task && (this.task.status === "waiting" || this.task.status === "running")) {
          this.timer = setTimeout(this.queryGenerate, 4000);
        } else {
          clearTimeout(this.timer);
        }
      });
    },
    imageUrl(url, isExternal) {
      return imageUrl(url, isExternal);
    },
  },
  mounted() {
    this.queryGenerate();
  },
  watch: {
    data: function () {
      this.queryGenerate();
    }
  }
};
</script>

<style lang="scss" scoped>
.analysis-result {
  margin: 0 10px 10px 10px;

  .el-card {
    background-color: white !important;
  }

  .analysis-divider.el-divider {
    ::v-deep .el-divider__text {
      background-color: #f5f7fa;
    }
  }

  .el-divider {
    ::v-deep .el-divider__text {
      font-weight: bold !important;
      font-size: 16px;
    }
  }

  .highlight {
    font-weight: bold;
    font-size: 18px;

    .el-tag {
      font-size: 18px;
    }
  }

  .primnum-card {
    margin-top: 10px;

    ::v-deep .el-card__body {
      padding: 15px 20px;
    }

    .primnum {
      float: left;
      font-size: 14px;
      margin-bottom: -12px;

      .title {
        font-size: 16px;
        font-weight: bold;
      }
    }
  }


  .score-summary {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 14px;
  }

  .score-right {
    float: right;
  }

  .primnum-right {
    float: right;
  }

  .content-text {
    font-size: 14px;
  }
}
</style>